import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { FeatureAccessInsightsLoadAction } from '../../domains/featureAccessInsights/actions.types';

import type { FeatureAccessInsightsLifecycle } from './types';

const initialState: FeatureAccessInsightsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<FeatureAccessInsightsLifecycle, FeatureAccessInsightsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FEATURE_ACCESS_INSIGHTS.LOAD_PENDING':
      return setPending();
    case 'FEATURE_ACCESS_INSIGHTS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    case 'FEATURE_ACCESS_INSIGHTS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    default:
      return state;
  }
};

export default reducer;
